module.exports = __webpack_public_path__ + "img/Logo_Dark.7d9ec9b1.svg";